import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";

const Services = () => {
  const navigate = useNavigate();

  return (
    <section className="services-hero">
      {/* Top-right Design Planning button */}
      <button
        className="design-planning-btn"
        onClick={() => navigate("/services/main")}
      >
        Design Planning ▶
      </button>

      <div className="hero-content">
        <p className="hero-tag">NOVA PEX CONSTRUCTION</p>
        <h1>Our Services</h1>
        <p className="hero-sub">
          Delivering excellence in residential, commercial and interior
          construction solutions.
        </p>
      </div>
    </section>
  );
};

export default Services;